/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-unused-vars */
import axios from 'axios';
import { BehaviorSubject } from 'rxjs';
import i18n from 'i18n/config';
import {
  INTERNAL_SERVER_ERROR,
  NOT_FOUND,
  UNAUTHORIZED,
  USER_LOCAL_STORE,
  BAD_REQUEST,
  CONSTANTS,
  MAINTENANCE,
} from '../constants';
import SnackbarUtils from '../utils/SnackbarUtils';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

const isLogged = JSON.parse(localStorage.getItem(USER_LOCAL_STORE));
const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem(USER_LOCAL_STORE)),
);

function logout() {
  localStorage.removeItem(USER_LOCAL_STORE);
  currentUserSubject.next(null);
  return window.location.replace('/login');
}

export function defaultRequestHeaders() {
  const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORE));
  if (user && user.access_token) {
    return {
      Authorization: `Bearer ${user.access_token}`,
    };
  }
  return {};
}

export const apiBase = (options) => new Promise((resolve, reject) => {
  API(options)
    .then((response) => {
      resolve(response);
    })
    .catch((errors) => {
      reject(errors);
    });
});

export const apiBaseGuideImage = (options, loader) => new Promise(async (resolve, reject) => {
  const body = new FormData();
  const image = await loader.file;
  body.append('image', image);
  API({
    method: options.method,
    url: options.url,
    data: body,
  })
    .then((response) => {
      resolve({ default: `${response.data.data}` });
    })
    .catch((errors) => {
      reject(errors);
    });
});

const err = (error) => {
  const messError = error;
  const { response } = messError;
  if (response) {
    switch (response.status) {
      case UNAUTHORIZED:
        SnackbarUtils.error(CONSTANTS.UNAUTHORIZED_MESSAGE_SYSTEMS[i18n.language]);
        logout();
        break;
      case MAINTENANCE:
        if (!isLogged) {
          window.location.href = '/maintenance';
        } else {
          window.location.href = '/admin/maintenance';
        }
        break;
      case INTERNAL_SERVER_ERROR:
        SnackbarUtils.error(CONSTANTS.ERROR_MESSAGE_SYSTEMS[i18n.language]);
        break;
      case BAD_REQUEST:
        if (response?.config?.config?.uploadFile) {
          break;
        }
        SnackbarUtils.error(response.data.errors[i18n.language]);
        break;
      default:
        break;
    }
  }
  return Promise.reject(error);
};

API.interceptors.request.use(
  (config) => ({
    ...config,
    headers: {
      ...config.headers,
      ...defaultRequestHeaders(),
    },
  }),
  err,
);

API.interceptors.response.use((response) => response, err);
